/*
 * Automatically generated by 'ng g ng-alain:plugin icon'
 * @see https://ng-alain.com/cli/plugin#icon
 */

import {
  AlipayCircleOutline,
  ApiOutline,
  AppstoreOutline,
  ArrowDownOutline,
  BookOutline,
  CloudOutline,
  CopyrightOutline,
  CustomerServiceOutline,
  DashboardOutline,
  DatabaseOutline,
  DingdingOutline,
  DislikeOutline,
  DownloadOutline,
  ForkOutline,
  FrownOutline,
  FullscreenExitOutline,
  FullscreenOutline,
  FundOutline,
  GithubOutline,
  GlobalOutline,
  HddOutline,
  LaptopOutline,
  LikeOutline,
  LockOutline,
  LogoutOutline,
  MailOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  MessageOutline,
  PayCircleOutline,
  PieChartOutline,
  PrinterOutline,
  RocketOutline,
  ScanOutline,
  SettingOutline,
  ShareAltOutline,
  ShoppingCartOutline,
  SoundOutline,
  StarOutline,
  SolutionOutline,
  TaobaoCircleOutline,
  TaobaoOutline,
  TeamOutline,
  ToolOutline,
  TrophyOutline,
  UsbOutline,
  UserOutline,
  WeiboCircleOutline,
  ContainerOutline,
} from '@ant-design/icons-angular/icons';

export const ICONS_AUTO = [
  AlipayCircleOutline,
  ApiOutline,
  AppstoreOutline,
  ArrowDownOutline,
  BookOutline,
  CloudOutline,
  CopyrightOutline,
  CustomerServiceOutline,
  DashboardOutline,
  DatabaseOutline,
  DingdingOutline,
  DislikeOutline,
  DownloadOutline,
  ForkOutline,
  FrownOutline,
  FullscreenExitOutline,
  FullscreenOutline,
  FundOutline,
  GithubOutline,
  GlobalOutline,
  HddOutline,
  LaptopOutline,
  LikeOutline,
  LockOutline,
  LogoutOutline,
  MailOutline,
  MenuFoldOutline,
  MenuUnfoldOutline,
  MessageOutline,
  PayCircleOutline,
  PieChartOutline,
  PrinterOutline,
  RocketOutline,
  ScanOutline,
  SettingOutline,
  ShareAltOutline,
  ShoppingCartOutline,
  SoundOutline,
  StarOutline,
  SolutionOutline,
  TaobaoCircleOutline,
  TaobaoOutline,
  TeamOutline,
  ToolOutline,
  TrophyOutline,
  UsbOutline,
  UserOutline,
  WeiboCircleOutline,
  ContainerOutline,
];
